/**
 * Check if object is audit object
 * @param object - Object to check if is audit
 * @returns True if is audit
 */
export function isAudit<T extends TAudit>(object: T): object is T {
  return !!(object as TAudit).id;
}
